import moment from 'moment';

class SalesTask {
    constructor(json) {
        if (json) {
            this.storageId = json.storageId;
            this.id = json.id;
            this.customerId = json.customerId;
            this.taskType = json.taskType;
            this.description = json.description;
            this.dueAt = moment(json.dueAt);
            this.assignedUserId = json.assignedUserId;
            this.completedAt = json.completedAt ? moment(json.completedAt) : null;
            this.outcomeNote = json.outcomeNote;
        } else {
            this.storageId = null;
            this.id = null;
            this.customerId = null;
            this.taskType = 1;
            this.description = '';
            this.dueAt = null;
            this.assignedUserId = null;
            this.completedAt = null;
            this.outcomeNote = null;
        }
    }
}

export default SalesTask;
